import React from "react";
import Header from "../../components/Header";
import BankTransactionsTable from "../../tables/Transactions/BankTransaction";
import { PRIVILEGES } from "../../utils/privileges";
import { hasPermission } from "../../utils/permissionChecker";
import { useSelector } from "react-redux";
const Transactions = () => {

  const { user } = useSelector((state) => state.auth);

  return (
    <>
      {hasPermission(user, PRIVILEGES.VIEW_TRANSACTIONS) && (
        <div>
          {" "}
          <div className="mt-[14px] mb-6">
            <Header text="Wallet Transactions" />
          </div>
          <div>
            <BankTransactionsTable />
          </div>
        </div>
      )}

    </>


  );
};

export default Transactions;
